import { ProductAddonTypeTyKeys } from '@teinor/erp/types/company/config/parameter'
import useTwinTranslation from '../useTwinTranslation'

const useProductAddonTypeDict = () => {
    const { t } = useTwinTranslation()
    const productAddonTypeDict: Record<ProductAddonTypeTyKeys, {name: string, value: number}> = {
        0: { name: t('bothM', 'Ambos'), value: 0 },
        1: { name: t('justAddonSells', 'Sólo complementos de venta'), value: 1 },
        2: { name: t('justAddonBuys', 'Sólo complementos de compra'), value: 2 },
        3: { name: t('unifyAddons', 'Unificar complementos'), value: 3 },
    }
    return productAddonTypeDict
}

export default useProductAddonTypeDict